import React from "react";
import { Sheet } from "react-modal-sheet";
import EmailStep from "./EmailStep";
import PaymentStep from "./PaymentStep";
import { SheetHeader, SheetTitle } from "./StyledComponents";
import Config from "../Config";

const PaymentSheet = ({
    isOpen,
    onClose,
    step,
    userEmail,
    setUserEmail,
    setStep,
    selectedPaymentOption,
    availableMethods,
    charges,
    totalPayment,
    totalDuesAmount,
    selectedDuesTotal,
    gstAmount,
    gateway,
    isBookingPayment,
    enableDueSelection,
    chargesTransactionLoading,
    isProcessing,
    onPaymentOptionClick,
    onPayNow,
    onFetchCharges,
    renderPaymentMethodIcon,
    renderPaymentMethodLabel,
    renderPaymentMethodDescription
}) => {

    const getSheetTitle = () => {
        if (step === 2) return "Enter Your Email";
        if (step === 3) return "Select Payment Method";
        return "";
    };

    const renderGatewayInfo = () => {
        if (gateway === Config.PAYMENT_GATEWAY.EASEBUZZ) { // EASEBUZZ
            return <div className="text-xs text-gray-500 mb-2">Payment Gateway: Easebuzz</div>;
        } else if (gateway === Config.PAYMENT_GATEWAY.CASHFREE) { // CASHFREE
            return <div className="text-xs text-gray-500 mb-2">Payment Gateway: Cashfree</div>;
        } else {
            return <div className="text-xs text-gray-500 mb-2">Payment Gateway: PayU</div>;
        }
    };

    return (
        <Sheet
            isOpen={isOpen}
            onClose={onClose}
            className="mx-auto md:max-w-sm"
            detent="content-height"
            disableScrollLocking={true}
            overlayClassName="bg-neutral-900 backdrop-blur-sm bg-opacity-70"
        >
            <Sheet.Container>
                <SheetHeader>
                    <SheetTitle>{getSheetTitle()}</SheetTitle>
                </SheetHeader>
                <Sheet.Content>
                    <Sheet.Scroller className="overflow-y-auto">
                        {step === 2 && (
                            <EmailStep
                                userEmail={userEmail}
                                setUserEmail={setUserEmail}
                                setStep={setStep}
                            />
                        )}
                        {step === 3 && (
                            <PaymentStep
                                selectedPaymentOption={selectedPaymentOption}
                                availableMethods={availableMethods}
                                charges={charges}
                                totalPayment={totalPayment}
                                totalDuesAmount={totalDuesAmount}
                                selectedDuesTotal={selectedDuesTotal}
                                gstAmount={gstAmount}
                                isBookingPayment={isBookingPayment}
                                enableDueSelection={enableDueSelection}
                                chargesTransactionLoading={chargesTransactionLoading}
                                isProcessing={isProcessing}
                                onPaymentOptionClick={onPaymentOptionClick}
                                onPayNow={onPayNow}
                                renderGatewayInfo={renderGatewayInfo}
                                renderPaymentMethodIcon={renderPaymentMethodIcon}
                                renderPaymentMethodLabel={renderPaymentMethodLabel}
                                renderPaymentMethodDescription={renderPaymentMethodDescription}
                            />
                        )}
                    </Sheet.Scroller>
                </Sheet.Content>
            </Sheet.Container>
        </Sheet>
    );
};

export default PaymentSheet;